/**
 * This extension adds support for custom ajax links that cannot be opened in new window
 */
export function registerAjaxLinkListeners(snippet: HTMLElement, naja: any): void {
    snippet.querySelectorAll('.ajax-link').forEach(element => {
        element.addEventListener('click', () => {
            const url = element.getAttribute('data-url');

            if (url === null || ! naja.uiHandler.isUrlAllowed(url) || element.classList.contains('disabled')) {
                return;
            }

            element.classList.add('disabled');

            setTimeout(() => element.classList.remove('disabled'), 1000);

            naja.makeRequest('GET', url, null, {history: false, unique: false});
        });
    });
}
